import _isNil from "lodash/isNil";
import _get from "lodash/get";
// eslint-disable-next-line import/no-cycle -- directive added automatically by Shepherd migration
import { getImageBySize, getNameWithFallbacks } from '../utils'; // eslint-disable-next-line import/no-cycle -- directive added automatically by Shepherd migration

import { getInstitution, getProduct } from './common';
/**
 * Gets Apply Now link urk
 *
 * @param   {Object} marketplaceEntity  Marketplace Offer
 *
 * @return  {string}                    Apply Now URL
 */

export var getApplyLink = function getApplyLink(marketplaceEntity) {
  return _get(marketplaceEntity, 'details.redirect_link.value');
};
/**
 * Gets max APR%
 * (divided by 100 because marketplace uses a value like 1234 to represent 12.34%)
 *
 * @param   {Object} marketplaceEntity  Marketplace Offer
 *
 * @return  {number}                    Max APR
 */

export var getAprMax = function getAprMax(marketplaceEntity) {
  var maxApr = _get(marketplaceEntity, 'details.max_apr.value');

  return _isNil(maxApr) ? maxApr : maxApr / 100;
};
/**
 * Gets min APR%
 * (divided by 100 because marketplace uses a value like 1234 to represent 12.34%)
 *
 * @param   {Object} marketplaceEntity  Marketplace Offer
 *
 * @return  {number}                    Min APR
 */

export var getAprMin = function getAprMin(marketplaceEntity) {
  var minApr = _get(marketplaceEntity, 'details.min_apr.value');

  return _isNil(minApr) ? minApr : minApr / 100;
};
/**
 * Gets the tagline text
 *
 * @param   {Object} marketplaceEntity  Marketplace Offer
 *
 * @return  {string}                    Tagline text
 */

export var getBottomLine = function getBottomLine(marketplaceEntity) {
  return _get(marketplaceEntity, 'details.tagline.value');
};
/**
 * Gets the min FICO score
 *
 * @param   {Object} marketplaceEntity  Marketplace Offer
 *
 * @return  {number}                    Min FICO score (0 indicates no min score)
 */

export var getFicoMin = function getFicoMin(marketplaceEntity) {
  return _get(marketplaceEntity, 'details.min_fico.value');
};
/**
 * Gets the cons bullets
 *
 * @param   {Object} marketplaceEntity  Marketplace Offer
 *
 * @return  {string[]}                  List of cons
 */

export var getConsBullets = function getConsBullets(marketplaceEntity) {
  return _get(marketplaceEntity, 'details.cons_bullets.value');
};
/**
 * Gets the alt text for the associated image
 *
 * @param   {Object} marketplaceEntity  Marketplace Offer
 *
 * @return  {string}                    Alt text
 */

export var getImageAltText = function getImageAltText(marketplaceEntity) {
  return _get(marketplaceEntity, 'details.image_alt_text.value');
};
/**
 * Gets the source URL for the associated image
 *
 * @param   {Object} marketplaceEntity  Marketplace Offer
 * @param   {string} [size]             Desired size of image, from constants.IMAGE_SIZES
 *
 * @return  {string}                    Image URL
 */

export var getImageSrc = getImageBySize;
/**
 * Get the issuer
 *
 * @param   {Object} marketplaceEntity  The marketplace entity
 * @return  {string}                    Issuer name
 */

export var getIssuerName = function getIssuerName(marketplaceEntity) {
  return _get(getInstitution(marketplaceEntity), 'name');
};
/**
 * Gets the Review link URL
 *
 * @param   {Object} marketplaceEntity  Marketplace Offer
 *
 * @return  {string}                    Review URL
 */

export var getLearnMoreLink = function getLearnMoreLink(marketplaceEntity) {
  return _get(marketplaceEntity, 'details.nw_review_link.value');
};
/**
 * Gets the name to display
 *
 * @param   {Object} marketplaceEntity  Marketplace entity
 *
 * @return  {string}                    The offer name
 */

export var getName = getNameWithFallbacks;
/**
 * Gets the pros bullets
 *
 * @param   {Object} marketplaceEntity  Marketplace Offer
 *
 * @return  {string[]}                  List of pros
 */

export var getProsBullets = function getProsBullets(marketplaceEntity) {
  return _get(marketplaceEntity, 'details.pros_bullets.value');
};
/**
 * Gets the qualifications bullets
 *
 * @param   {Object} marketplaceEntity  Marketplace Offer
 *
 * @return  {string[]}                  List of qualifications
 */

export var getQualificationsBullets = function getQualificationsBullets(marketplaceEntity) {
  return _get(marketplaceEntity, 'details.qualifications_bullets.value');
};
/**
 * Gets the star rating
 *
 * @param   {Object} marketplaceEntity  Marketplace Offer
 *
 * @return  {number}                    The star rating
 */

export var getStarRating = function getStarRating(marketplaceEntity) {
  return _get(marketplaceEntity, 'details.rating_stars.value');
};
/**
 * Gets the star rating tooltip
 *
 * @return  {string}                    The star rating tooltip
 */

export var getStarRatingTooltip = function getStarRatingTooltip() {
  return "NerdWallet's ratings are determined by our editorial team. The scoring formula takes into account factors like maximum rates, variety of loan options, visibility of borrower requirements, accessibility, speed of funding, fees and more.";
};
/**
 * Gets the sub product type
 *
 * @param   {Object} marketplaceEntity  Marketplace Offer
 *
 * @return  {String}                    The sub product type
 */

export var getSubProductType = function getSubProductType(marketplaceEntity) {
  return _get(getProduct(marketplaceEntity), 'details.type.value');
};